/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row3_KbInputs */

const en_mk_cmp_row3_kb = /** @type {(inputs: Mk_Cmp_Row3_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built in from the Team tier`)
};

const id_mk_cmp_row3_kb = /** @type {(inputs: Mk_Cmp_Row3_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawaan sejak tier Tim`)
};

/**
* | output |
* | --- |
* | "Built in from the Team tier" |
*
* @param {Mk_Cmp_Row3_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row3_kb = /** @type {((inputs?: Mk_Cmp_Row3_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row3_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row3_kb(inputs)
	return en_mk_cmp_row3_kb(inputs)
});